/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DriverTeam } from '@shared/models/driver-team';

@Pipe({
    name: 'driverNames',
    standalone: false
})
export class DriverNamesPipe implements PipeTransform {

  transform(value: DriverTeam, args = {onlyAbbreviations: false}): string {
    const drivers = [...value.additionalDrivers];
    drivers.unshift(value.mainDriver);
    return drivers.filter(driver => driver != null).map(driver => {
      if (args.onlyAbbreviations) {
        return driver.abbreviation;
      }
      return driver.firstName + ' ' + driver.lastName;
    }).join(', ');
  }
}
